import { ServiceRequest } from "src/utils/service-request"
import { DATALAKE_CHATBOT_PATH } from "src/utils/api-routes"
import { TokenService } from "./token-service"

class ChatbotService {
    constructor(){
        this.ServiceRequest = new ServiceRequest()
        this.tokenService = new TokenService()
    }

    async sendMessage(body){
        return await this.ServiceRequest.post(DATALAKE_CHATBOT_PATH, body)
    }

    async getMessage(message_id, session_id) {
        return await this.ServiceRequest.get(`${DATALAKE_CHATBOT_PATH}?message_id=${message_id}&session_id=${session_id}`)
    }
}

export default ChatbotService